import dayjs from "dayjs";

import {
  HotelsSortOptions,
  type HotelsSortValue,
} from "@/features/hotels/types/types";
import type { HotelSearchFormInputValues } from "@/features/hotels/utils/hotelsValidation";
import { SortOrder } from "@/types/enums";

export const initialHotelSearchFormValues: HotelSearchFormInputValues = {
  destination: null,
  dates: {
    checkIn: dayjs().add(1, "day").startOf("day").toDate(),
    checkOut: dayjs().add(2, "day").startOf("day").toDate(),
  },
  rooms: [
    {
      adults: 1,
      children: 0,
      childrenAges: [] as number[],
    },
  ],
};

export const initialSortValue: HotelsSortValue = {
  field: HotelsSortOptions.RECOMMENDED,
  order: SortOrder.ASC,
};
